/**
 * Fee Configuration
 *
 * Central location for fee rates.
 * Change COLLECTION_FEE_RATE here to update the fee globally.
 */

/**
 * Collection fee rate applied to all payments
 * Default: 8% (0.08)
 */
export const COLLECTION_FEE_RATE = 0.08

/**
 * Fee rate as a percentage for display
 */
export const COLLECTION_FEE_PERCENTAGE = COLLECTION_FEE_RATE * 100
